import { KlearDate } from '@klear/date'
import type { KlearDateJson } from '@klear/date/json'

const KLEAR_DATE_WIRE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export function klearDateWireOrUndefined(value: string | null | undefined): KlearDateJson | undefined {
  return value && KLEAR_DATE_WIRE_PATTERN.test(value) ? (value as KlearDateJson) : undefined
}

const padded = (value: number, width = 2): string => `${value}`.padStart(width, '0')

export function klearDateToJsDate(date: KlearDate | undefined | null): Date | undefined {
  if (date == null) return undefined
  // eslint-disable-next-line no-restricted-globals -- calendar widgets require a local-midnight JS Date
  return new Date(date.yearValue, date.monthValue - 1, date.dayValue)
}

export function klearDateFromJsDate(date: Date | undefined | null): KlearDate | undefined {
  if (date == null) return undefined
  return KlearDate.parse(`${padded(date.getFullYear(), 4)}-${padded(date.getMonth() + 1)}-${padded(date.getDate())}`)
}
